import React from 'react'
import { IonChip, IonCol, IonLabel, IonRow } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import ChipComponent from '../components/Chips.component'

const svgData = [
  {
    id: 'front-body',
    label: 'additionalAssessments.bodySurvey.front',
    chips: ['R', 'L'],
    svgPath:
      'M61 4.5L71.5 2L83.5 4.5L92.5 16L90.5 39.5L86 41L83.5 54.5L86 60L106 68.5L118 77L122.5 83L125.5 90V107.5V120.5L129 147L133 160.5L132 192L137 202.5L141.5 217.5L127 225H120.5V205H118L113.5 210.5L111 209L115 200.5L122.5 195L113.5 159.5L115 138.5L105 106L99 124L97 136.5L96 157.5L103.5 168.5V175.5L111 198.5L107 238.5L106.5 248L101.5 276V316.5L105 335.5L89.5 391.5L97.5 405V409.5L86.5 413.5H81L79.5 408L78.5 392.5L83.5 379.5V352.5L79.5 341.5L78.5 328L83.5 312.5L78.5 301.5L82 274L76.5 245L74.5 226V221L71.5 222L69 221V226V235.5L68 245L62.5 274L65 301.5L60.5 312.5L65.5 328L65 341.5L60.5 352.5L61.5 379.5L65.5 392.5V408L63.5 413.5H57.5L46.5 409.5V405L55 391.5L39.5 335.5L41.5 316.5L43 276L38 248L37 238.5L33 198.5L40.5 175.5V168.5L46.5 157.5L48 136.5L45.5 124L39.5 106L28.5 138.5L29.5 159.5L21 195L30 201.5L33 210.5L31.5 211.5L25.5 204L23.5 205V225H16.5L2 217.5L6 202.5L11.5 192L11 159.5L14 147L16 135L18 120.5L19 107.5V90L21.5 83L26.5 77L38.5 68.5L59 60L61 54.5L58 41L54 39.5L52.5 16L61 4.5Z',
  },
  {
    id: 'back-body',
    label: 'additionalAssessments.bodySurvey.back',
    chips: ['L', 'R'],
    svgPath:
      'M61 4.5L71.5 2L83.5 4.5L92.5 16L90.5 39.5L86 41L83.5 54.5L86 60L106 68.5L118 77L122.5 83L125.5 90V107.5V120.5L129 147L133 160.5L132 192L137 202.5L141.5 217.5L127 225H120.5V205H118L113.5 210.5L111 209L115 200.5L122.5 195L113.5 159.5L115 138.5L105 106L99 124L97 136.5L96 157.5L103.5 168.5V175.5L111 198.5L107 238.5L106.5 248L101.5 276V316.5L105 335.5L89.5 391.5L97.5 405V409.5L86.5 413.5H81L79.5 408L78.5 392.5L83.5 379.5V352.5L79.5 341.5L78.5 328L83.5 312.5L78.5 301.5L82 274L76.5 245L74.5 226V221L71.5 222L69 221V226V235.5L68 245L62.5 274L65 301.5L60.5 312.5L65.5 328L65 341.5L60.5 352.5L61.5 379.5L65.5 392.5V408L63.5 413.5H57.5L46.5 409.5V405L55 391.5L39.5 335.5L41.5 316.5L43 276L38 248L37 238.5L33 198.5L40.5 175.5V168.5L46.5 157.5L48 136.5L45.5 124L39.5 106L28.5 138.5L29.5 159.5L21 195L30 201.5L33 210.5L31.5 211.5L25.5 204L23.5 205V225H16.5L2 217.5L6 202.5L11.5 192L11 159.5L14 147L16 135L18 120.5L19 107.5V90L21.5 83L26.5 77L38.5 68.5L59 60L61 54.5L58 41L54 39.5L52.5 16L61 4.5Z',
  },
]

const BodyExternalSkin: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div id='BodyExternalSkinSection' className='body-section'>
      {svgData.map((section) => (
        <div key={section.id} id={section.id}>
          <IonChip outline className='body-survey-chip body-survey-chip-size mb-5'>
            <IonLabel className='body-survey-chip-label'>{t(section.label)}</IonLabel>
          </IonChip>
          <IonRow className='image-container mobile-nowrap'>
            <IonCol className='mt-20 left-3'>
              <ChipComponent label={section.chips[0]} />
            </IonCol>
            <IonCol>
              <div className='external-skin'>
                <svg viewBox='0 0 143 415' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d={section.svgPath}
                    fill='var(--ion-color-zoll-gray-blue)'
                    stroke='#658197'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeDasharray='3 5'
                  />
                </svg>
              </div>
            </IonCol>
            <IonCol className='mt-20 right-3'>
              <ChipComponent label={section.chips[1]} />
            </IonCol>
          </IonRow>
        </div>
      ))}
    </div>
  )
}

export default BodyExternalSkin
